const languageByDomainDetector = require('./languageByDomainDetector')
const ignoreRoutes = require('./ignoreRoutes')

module.exports = {
  ignoreRoutes,
  localePath: 'public/static/locales',
  defaultLanguage: 'en',
  fallbackLng: 'en',
  otherLanguages: ['nl', 'de', 'fr', 'hu', 'es', 'pt-BR'],
  load: 'currentOnly',
  customDetectors: [languageByDomainDetector],
  detection: {
    order: ['querystring', 'domain'],
  },
}
